import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  primary: "#0760ad",
  white: "#FFFFFF"
};

const PackageCTA = () => {
  return (
    <div className="py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: COLORS.primary }}>
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold text-white mb-6">
            Need Help Choosing a Package?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Our health advisors can help you select the perfect package for your needs
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <motion.a
              href="/contact"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 rounded-full font-medium text-[#0760ad] bg-white shadow-lg"
            >
        Contact Us
          </motion.a>
           
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PackageCTA;